<template>
  <div class="h-screen flex flex-col items-center justify-center bg-purple-900">
    <div class="text-4xl font-medium text-red-500 mb-4" data-content="403">
      403 - В доступе отказано
    </div>

    <div class="font-medium mb-6 text-white text-xl">
      К сожалению, у вас нет разрешения на доступ к этой странице.
    </div>

    <div>
      <button class="border-2 border-blue-500 font-medium hover:border-white hover:text-white px-3 py-1 rounded text-blue-500 text-lg"
              @click="$router.push({name: 'Home'})">Вернутся на главную</button>
    </div>
  </div>
</template>
<script>
export default {
  name: '403'
}
</script>